module.exports = __webpack_public_path__ + "static/media/agevie.8f6d2693.png";